import { NgModule } from '@angular/core';
import { DsTooltipModule } from '@skyeng/libs/shared/ui-kit-v2/tooltip';

import { LaboratoryTooltipDirective, LaboratoryTooltipReferenceDirective } from './tooltip.directive';

/**
 * `labTooltip` для standalone-кода: в шаблон импортируй этот модуль, а не голую директиву.
 *
 * Директива подсказку не рисует — она открывает портальный `DsTooltipComponent`, который объявлен
 * только в `DsTooltipModule` (`standalone: false`) и оттуда же берёт `CommonModule`. Без модульной
 * области видимости первое наведение в JIT-контуре (Storybook, TestBed) роняет
 * `NG0302: The pipe 'async' could not be found in the 'DsTooltipComponent' component`; в AOT
 * область разрешается на компиляции, и прод-сборку это не задевает. Голая
 * `LaboratoryTooltipDirective` остаётся в публичном API ради DI — `injector.get(...)` в спеках.
 *
 * Именно NgModule, а не экспортируемый массив, потому что у модуля есть граница экспорта:
 * `DsTooltipModule` стоит только в `imports`, и селекторы `ds-*` не утекают к потребителю — Лаба
 * по-прежнему собирается из `lab-*`. Плоский массив, развёрнутый в `imports` потребителя, отдал бы
 * ему и `DsTooltipComponent`, и `dsTooltip`.
 */
@NgModule({
  imports: [DsTooltipModule, LaboratoryTooltipDirective, LaboratoryTooltipReferenceDirective],
  exports: [LaboratoryTooltipDirective, LaboratoryTooltipReferenceDirective],
})
export class LaboratoryTooltipModule {}
